import {
    AcquisitionPropertyTemplateName,
    useGetAcquisitionPropertyFileTemplateLazyQuery
} from '../../../__generated__/generated_types';
import { useEffect } from "react";
import { base64ToBlob, downloadDataAsFile } from "../../../utils/file-helpers";

export interface IFetchTemplateCsv {
    fetchTemplate: (propertyId: string, templateName: AcquisitionPropertyTemplateName) => void
}


export function useFetchTemplateCsv(filePrefix?: string): IFetchTemplateCsv {
    const [getTemplate, {loading, data}] = useGetAcquisitionPropertyFileTemplateLazyQuery({
        fetchPolicy: "no-cache",
    });

    useEffect(() => {
        if(!loading && data?.getAcquisitionPropertyFileTemplate) {
            const csvData = data.getAcquisitionPropertyFileTemplate;
            const blob = base64ToBlob(csvData.base64ZipFile, "application/zip");
            let fileName = "template.zip";
            if(filePrefix) {
                fileName = `${filePrefix}-${fileName}`;
            }
            downloadDataAsFile(blob, fileName);
        }
    }, [loading, data]);

    const fetchTemplate = (propertyId: string, templateName: AcquisitionPropertyTemplateName) => {
        getTemplate({
            variables: {
                propertyId: propertyId,
                templateName: templateName
            }
        });
    };

    return {
        fetchTemplate
    };
}